import PropertyUpdateModal from "./PropertyUpdateModal"

export default PropertyUpdateModal
